import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitTopRight16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowFitTopRight16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 3.501a1.5 1.5 0 0 0-1.5-1.5H5.534a.5.5 0 1 0 0 1h6.757L3 12.292V8.19h-.5.5a.5.5 0 0 0-1 0h.5H2V14h5.81a.5.5 0 0 0 0-1H3.708l9.291-9.292v6.757a.5.5 0 0 0 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitTopRight16);
